import { render } from "./EventCreate.vue?vue&type=template&id=3fc3da7b&scoped=true"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"

import "./EventCreate.vue?vue&type=style&index=0&id=3fc3da7b&lang=css&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc3da7b"]])

export default __exports__